module.exports = __webpack_public_path__ + "static/media/spaceBackground2.74223b7f.png";